export default{
    room:'اتاق',
    roomTitle: 'عنوان',
    roomRecallNumber: 'شماره فراخوان',
    roomStatus: 'وضعیت',
    rooms:'مدیریت اتاق‌ها',
    editRoom:'ویرایش اتاق',
    addRoom:'اتاق جدید',
    unit : 'جستجو براساس واحد',
    doctor : 'doctor',
    triage : 'triage',
    roomType : 'نوع اتاق',
    patientsMonitoring : 'مانیتورینگ بیمارها',
    doctorsMonitoring : 'مانیتورینگ پزشک ها',
    queueRoomsOfUnit : 'صف پذیرش بیمارها',
    accounting : 'حسابداری',
}